import React from 'react';
import PropTypes from 'prop-types';
import IncentiveCatalog from '../IncentiveCatalog/IncentiveCatalog';
import IncentivePreferences from '../IncentivesPreferences/IncentivePreferences';
import { FormatAsDollars, FormatCarName } from './../../utils/Helpers/Format';
import { useIntl, FormattedMessage } from 'react-intl';
import './EVIncentives.scss';

const EVIncentives = ({ car, incentives, usedEv, zipcode, purchaseMethod }) => {
  const intl = useIntl();
  const list = Array.isArray(incentives) ? incentives : [];

  const eligibleIncentives = list.filter((inc) => {
    const evaln = inc?.evaluation || {};
    if (usedEv) {
      return !!inc?.applicable_to_used_vehicles;
    }
    if (evaln.eligibility === 'ineligible') {
      return false;
    }
    if (purchaseMethod === 'lease') {
      return !!evaln.applicable_to_lease;
    }
    if (purchaseMethod === 'cash' || purchaseMethod === 'loan') {
      return !!evaln.applicable_to_ownership;
    }
    return false;
  });

  const totalSavings = eligibleIncentives.reduce((sum, incentive) => {
    const evaln = incentive.evaluation || {};
    let amount = 0;

    if (purchaseMethod === 'cash' || purchaseMethod === 'loan') {
      if (evaln.amount_in_purchase > 0) {
        amount = evaln.amount_in_purchase;
      } else if (incentive.typical_amount !== 'N/A') {
        amount = incentive.max_amount;
      }
    } else if (purchaseMethod === 'lease') {
      if (evaln.amount_in_lease > 0) {
        amount = evaln.amount_in_lease;
      } else if (incentive.typical_amount !== 'N/A') {
        amount = incentive.max_amount;
      }
    }

    return sum + amount;
  }, 0);

  if (list.length === 0) return null;

  return (
    <section className="container-fluid EVIncentives">
      <div className="container">
        <div>
          <div className="row">
            <div className="col-12">
              <p className="mt-0 mb-3 text-center compare-title">
                <FormattedMessage
                  id="ev.incentives.title"
                  defaultMessage="Up to {savings} in tax credits and rebates are potentially available {lineBreak} for the {car}"
                  description="EV Incentives Title"
                  values={{
                    savings: <strong>{FormatAsDollars(totalSavings)}</strong>,
                    lineBreak: <br />,
                    car: FormatCarName(car),
                  }}
                />
              </p>
              <div className="text-center" style={{ marginBottom: '31px' }}>
                <IncentivePreferences
                  titleText="PERSONALIZE INCENTIVES"
                  btnText={
                    intl.formatMessage
                      ? intl.formatMessage({
                          id: 'personalizeIncentives',
                          defaultMessage: 'Personalize incentives',
                        })
                      : 'Personalize incentives'
                  }
                  zipcode={zipcode}
                />
              </div>
              <IncentiveCatalog
                incentives={eligibleIncentives}
                carousel={true}
                usedEv={usedEv}
                purchaseMethod={purchaseMethod}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EVIncentives;

EVIncentives.propTypes = {
  car: PropTypes.object,
  incentives: PropTypes.array,
  usedEv: PropTypes.bool,
  zipcode: PropTypes.string,
  purchaseMethod: PropTypes.oneOf(['lease', 'cash', 'loan']),
};
